import { Card, Modal } from "@mantine/core";
import { useState } from "react";
import MembersTable from "../../app/routes/admin/members/MembersTable";
import WidgetWrapper from "../WidgetWrapper/WidgetWrapper";

const OrgListWidget: React.FC<any> = () => {
  const [openOrgListModal, setOpenOrgListModal] = useState<boolean>(false);
  const [showSettings, setShowSettings] = useState<boolean>(false);

  return (
    <WidgetWrapper
      title="Medlemmer"
      widgetKey="orgList"
      onFullscreenClick={() => setOpenOrgListModal(true)}
      onShowSettingsClick={() => setShowSettings(!showSettings)}
    >
      <>
          <MembersTable showSettings={showSettings} />
        <Modal
          opened={openOrgListModal}
          onClose={() => setOpenOrgListModal(false)}
          title="Prosjektmedlemmer"
          size="80vw"
          centered
          overlayProps={{ blur: 2 }}
        >
          <Card px="sm" pt={"xs"} h={"80vh"} bg={"#fafafb"} bd={"1px solid var(--mantine-color-warmgray-1)"}>
            <MembersTable />
          </Card>
        </Modal>
      </>
    </WidgetWrapper>
  );
};
export default OrgListWidget;
